import _ from 'lodash'
import React from 'react';
import axios from 'axios';
import { connect } from 'react-redux'
import { matchPath } from 'react-router';
import { bindActionCreators } from 'redux';
import { sendRequest } from '../../modules/admin'
import {
  fetchLatest,
  newUserMember,
  newMember,
  changeFinished,
  newUserNotRequired,
  fetchAll,
  updateUser,
  subscribeMember,
  updateAndSubscribe
} from '../../modules/users'
import './member.scss';
import Webcam from "react-webcam";
import Alert from '../views/alert';
import Payment from '../views/payment';
import { BarLoader } from 'react-spinners';
import config from '../../variables/config';
import { isBlank } from '../helpers/validation';
import memberships, {
  formatMembershipPayAmount,
  clampFamilyChildCount,
  fetchMembershipPrices,
  DEFAULT_MEMBERSHIP_PRICES
} from '../helpers/memberships';
import {
  isActivelySubscribed,
  resolveStripeProductName,
  fetchPortalStripeMemberships,
  formatStripePayAmount,
  findStripePrice
} from '../helpers/stripeMembership';
import IosArrowDown from 'react-ionicons/lib/IosArrowDown';
import IosArrowRoundBack from 'react-ionicons/lib/IosArrowRoundBack';
import IosCloseCircleOutline from 'react-ionicons/lib/IosCloseCircleOutline';
import IosCheckmarkCircleOutline from 'react-ionicons/lib/IosCheckmarkCircleOutline';

const newMemberText = 'New Member';
const submitText = "Submit";
const tryAgainText = "Please try again later";
const errorText = "Error";
const loadingText = "Loading";
const monthlyText = 'Monthly';
const months12Text = '12 months';
const pleaseSelectUText = 'Please select a user';
const searchText = 'Search';
const searchPlaceholderText = 'Search by name or surname or email';
const noUsersFoundText = 'No users found';
const addUserText = 'Add new user';
const changeText = 'Change';
const pleaseSelectTText = 'Please select membership plan';
const selectMemberText = 'Membership plan';
const childrenOnPlanText = 'Children covered by this membership';
const coversTwoAdultsTwoChildrenText =
  'Covers 2 adults and 2 children (fixed plan).';
const totalText = 'Total';
const amountText = 'Amount';
const successText = 'Bank account created';
const stripeSuccessText = 'Membership created';
const failureText = 'Error while creating bank account';
const requestText = 'Subscribe request was sent';
const userSubscribedText = 'User already has a membership';
const takePictureText = "Take Picture";
const takeAgainText = "Take Again";
const addGuardianText = 'Add Guardian';
const saveGuardianText = 'Save Guardian';
const guardiansText = 'Guardians';
const deleteText = 'Delete';
const notSavedText = 'Please save';
const paySubmitText = 'Pay and Submit';
const stripeProductErrorText = 'Could not match a Stripe product for this plan';

const emptyAlert = {
  showAlert: false,
  message: '',
  type: '',
  callback: () => { }
}

class Member extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      email: '',
      firstName: '',
      lastName: '',
      address1: '',
      address2: '',
      city: '',
      country: '',
      county: '',
      postcode: '',
      phoneNumber: '',
      alert: _.clone(emptyAlert),
      selectedMember: {
        memberIndex: null,
        memberType: null
      },
      familyChildCount: 2,
      membershipPrices: null,
      stripePlans: [],
      stripePlansLoading: false,
      stripePlansError: '',
      openedMember: [],
      showPayment: false,
      paymentDone: false,
      paymentMethod: {},
      customerId: '',
      selectedUser: {
        selected: false,
        user: {}
      },
      search: '',
      searchResults: [],
      hasSearched: false,
      newUserRequired: false,
      subscriptionId: '',
      stripeProductName: '',
      pendingImage: '',
      redirectCompleted: false,
      redirectFailed: false,
      subscribeLoading: false,
      pictureTaken: false,
      image: '',
      guardians: [],
      deletedGuardians: [],
      openedGuardian: null,
      pictureQueue: []
    }

    this.webcamRef = React.createRef();
  }

  componentDidMount = () => {
    this.checkUrl();
    this.props.sendRequest(fetchAll)
    this.props.sendRequest(fetchLatest)
    if (config.useStripeMemberships) {
      this.loadStripeMemberships()
    } else {
      this.initOpened(memberships)
    }
    this.loadMembershipPrices()
  }

  getAvailableMemberships = () => {
    return config.useStripeMemberships ? this.state.stripePlans : memberships
  }

  loadStripeMemberships = async () => {
    this.setState({ stripePlansLoading: true, stripePlansError: '' })
    try {
      const plans = await fetchPortalStripeMemberships()
      this.setState({
        stripePlans: plans,
        stripePlansLoading: false
      }, () => this.initOpened(plans))
    } catch (error) {
      this.setState({
        stripePlans: [],
        stripePlansLoading: false,
        stripePlansError: error.message || 'Could not load Stripe membership products'
      })
    }
  }

  loadMembershipPrices = async () => {
    try {
      const raw = window.localStorage.getItem('userData')
      const token = raw ? JSON.parse(raw).token : null
      if (!token) {
        this.setState({ membershipPrices: DEFAULT_MEMBERSHIP_PRICES })
        return
      }
      const prices = await fetchMembershipPrices(token)
      this.setState({ membershipPrices: prices })
    } catch (e) {
      this.setState({ membershipPrices: DEFAULT_MEMBERSHIP_PRICES })
    }
  }

  checkUrl = () => {
    // GoCardless return URLs only — Southampton Stripe never redirects here.
    if (config.useStripeMemberships) return;

    const success = '/membershipSuccess/:id';
    const failure = '/membershipFailure/:id';

    const match = matchPath(this.props.history.location.pathname, {
      path: success,
      exact: true,
      strict: false
    })

    const match2 = matchPath(this.props.history.location.pathname, {
      path: failure,
      exact: true,
      strict: false
    })

    if (match !== null && typeof match.path === 'string' && match.path.substring(0, success.length) === success) {
      this.setState({
        redirectCompleted: true
      })
      console.log("About to subscribe")
      this.startRequest(match.params.id);
    } else if (match2 !== null && typeof match2.path === 'string' && match2.path.substring(0, failure.length) === failure) {
      this.setState({
        redirectFailed: true
      })
      this.failureClose();
    }
  }

  startRequest = (id) => {
    setTimeout(() => {
      this.setState({ subscribeLoading: true });
      this.props.sendRequest(subscribeMember, { id })
    }, 2000)
  }

  failureClose = () => {
    setTimeout(() => {
      this.animateClose();
      window.location = window.location.href.split('membershipFailure')[0]
    }, 2000)
  }

  initOpened = (memberships) => {
    this.setState({
      openedMember: [...new Array(memberships.length)].map((ignore, i) => this.state.openedMember[i] ? this.state.openedMember[i] : false)
    })
  }

  handleChange = (property, { target }) => {
    this.setState({
      [property]: target.value
    })
  }

  changePicture = (pictureCase, image, pictureQueue) => {
    switch (pictureCase) {
      case 1:
        this.setState({
          image: image,
          pictureQueue: pictureQueue
        })
        break;
      case 2:
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            user: {
              ...this.state.selectedUser.user,
              image: image
            }
          },
          pictureQueue: pictureQueue
        })
        break;
      case 3:
        var guardians = this.state.guardians;
        guardians[this.state.openedGuardian].image = image;
        this.setState({
          guardians: guardians,
          pictureQueue: pictureQueue
        })
        break;
      default:
        break;
    }
  }

  removePicture = (pictureCase) => {
    var pictureQueue = this.state.pictureQueue;
    pictureQueue.push(pictureCase === 3 ? 2 : 1);

    this.changePicture(pictureCase, '', pictureQueue);
  }

  takePicture = (pictureCase) => {
    if (!this.webcamRef.current) return;
    const imageSrc = this.webcamRef.current.getScreenshot();
    if (!imageSrc) return;

    var image = new Image();

    image.onload = () => {
      const width = image.width;
      const height = image.height;
      if (!width || !height) return;

      var canvas = document.createElement("canvas");
      const x = (width - height) / 2;

      canvas.width = height;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, x, 0, height, height, 0, 0, height, height);
      var pictureQueue = this.state.pictureQueue;
      pictureQueue.shift()
      this.changePicture(pictureCase, canvas.toDataURL("image/png"), pictureQueue)
    };

    image.src = imageSrc;
  }

  convert = (data) => {
    if (!data) return;
    var image = new Image();

    image.onload = () => {
      const width = image.width;
      const height = image.height;
      if (!width || !height) return;

      var canvas = document.createElement("canvas");
      const x = (width - height) / 2;

      canvas.width = height;
      canvas.height = height;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(image, x, 0, height, height, 0, 0, height, height);

      if (this.state.newUserRequired) {
        this.setState({ image: canvas.toDataURL("image/png") })
      } else if (this.state.selectedUser.selected) {
        this.setState({
          selectedUser: {
            ...this.state.selectedUser,
            user: {
              ...this.state.selectedUser.user,
              image: canvas.toDataURL("image/png")
            }
          }
        })
      }
    };

    image.src = data;
  }

  saveImage = async (image, domain) => {
    let token = JSON.parse(window.localStorage.getItem('userData')).token;
    const url = domain + '/ImageUploads/wackykingdom/upload';
    var ImageURL = image
    var block = ImageURL.split(";");
    var contentType = block[0].split(":")[1];
    var realData = block[1].split(",")[1];

    var blob = this.b64toBlob(realData, contentType);
    var formDataToUpload = new FormData();
    var filename = this.generateReferenceNumber('IMG') + '.png';
    formDataToUpload.append("file", blob, filename);

    const config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }

    await axios.post(url + '?access_token=' + token, formDataToUpload, config);

    return filename;
  }

  uploadImages = async () => {
    var image = '';
    const domain = config.serverURL;
    const header = 'data:image';
    if (
      (this.state.newUserRequired && this.state.image !== '') ||
      (this.state.selectedUser.selected &&
        this.state.selectedUser.user.image !== '' &&
        this.state.selectedUser.user.image.substring(0, header.length) === header)
    ) {
      try {
        image = await this.saveImage(
          this.state.newUserRequired ? this.state.image : this.state.selectedUser.user.image,
          domain
        );
      } catch (error) {
        console.log('submit (uploading image) - error:', error.message);
      }
    }
    for (var i = 0; i < this.state.guardians.length; i++) {
      var guardian = this.state.guardians[i];
      if (guardian.image && guardian.image.substring(0, header.length) === header) {
        guardian.image = await this.saveImage(guardian.image, domain);
      }
    }
    return image;
  }

  buildMembershipFields = (imageUserId) => {
    const idx = this.state.selectedMember.memberIndex;
    const plan = this.getAvailableMemberships()[idx];
    const isSibling = !!plan.sibling;
    const isFamily = !!plan.family;
    const type = plan.tier;
    const familyCount = (() => {
      if (!plan.family) return null;
      if (plan.familyPlan === 'twoAdultsTwoChildren') return 2;
      return clampFamilyChildCount(this.state.familyChildCount, plan);
    })();

    const m = {
      isPublic: false,
      isSibling: isSibling,
      isFamily: isFamily,
      userId: imageUserId || this.state.selectedUser.user.id,
      reference: this.generateReferenceNumber('WKM'),
      interval: this.state.selectedMember.memberType === 1 ? 'monthly' : 'yearly',
      type: type
    };
    if (isFamily && plan.familyPlan) {
      m.familyPlanType = plan.familyPlan;
    }
    if (isFamily && familyCount !== null) {
      m.familyChildCount = familyCount;
    }
    return m;
  }

  submit = async () => {
    if (!this.isFormValid()) return;

    const plan = this.getAvailableMemberships()[this.state.selectedMember.memberIndex];
    if (!plan) return;

    // Southampton: card payment → Stripe subscription → persist membership (no GoCardless).
    if (config.useStripeMemberships) {
      try {
        const stripeProductName = resolveStripeProductName(plan);
        const image = await this.uploadImages();
        this.setState({
          stripeProductName,
          pendingImage: image,
          showPayment: true
        });
      } catch (error) {
        const alert = _.clone(emptyAlert);
        alert.type = 'error';
        alert.showAlert = true;
        alert.message = error.message || stripeProductErrorText;
        alert.callback = () => this.setState({ alert: _.clone(emptyAlert) });
        this.setState({ alert });
      }
      return;
    }

    const image = await this.uploadImages();
    const isSibling = !!plan.sibling;
    const isFamily = !!plan.family;
    const type = plan.tier;
    const familyCount = (() => {
      if (!plan.family) return null;
      if (plan.familyPlan === 'twoAdultsTwoChildren') return 2;
      return clampFamilyChildCount(this.state.familyChildCount, plan);
    })();

    var data;
    if (this.state.newUserRequired) {
      data = {
        user: this.getUserObj(image),
        membership: this.buildMembershipFields()
      }
      if (this.state.customerId !== '')
        data.user.customerId = this.state.customerId;
    } else {
      data = {
        id: this.state.selectedUser.user.id,
        membership: {
          ...this.buildMembershipFields(),
          startDate: (new Date()).toString()
        }
      }
    }
    var m = this.state.selectedUser.user.membership;
    var check = { customer: false };
    let token = JSON.parse(window.localStorage.getItem('userData')).token;

    if (m && m.customerId && m.customerId !== '' && m.mandateId && m.mandateId !== '') {
      check = (await axios.post(config.serverURL + '/Memberships/checkCustomer' + '?access_token=' + token, { mandateId: m.mandateId, customerId: m.customerId })).data;
    }
    if (check.customer) {
      var data3 = {
        id: m.id,
        isSibling: isSibling,
        isFamily: isFamily,
        startDate: (new Date()).toString(),
        reference: this.generateReferenceNumber('WKM'),
        interval: this.state.selectedMember.memberType === 1 ? 'monthly' : 'yearly',
        type: type
      }
      if (isFamily && plan.familyPlan) {
        data3.familyPlanType = plan.familyPlan;
      }
      if (isFamily && familyCount !== null) {
        data3.familyChildCount = familyCount;
      }
      if (image && image !== '') {
        var data2 = {
          image: image
        }
        this.props.sendRequest(updateUser, { id: this.state.selectedUser.user.id, properties: data2 })
      }
      data3.guardians = this.state.guardians;
      data3.userId = this.state.selectedUser.user.id;
      data3.deletedGuardians = this.state.deletedGuardians;
      this.props.sendRequest(updateAndSubscribe, data3)
    } else {
      data.guardians = this.state.guardians;
      if (this.state.newUserRequired) {
        this.props.sendRequest(newUserMember, data)
      } else {
        if (image && image !== '') {
          var data4 = {
            image: image
          }
          this.props.sendRequest(updateUser, { id: this.state.selectedUser.user.id, properties: data4 })
        }
        data.userId = this.state.selectedUser.user.id;
        data.deletedGuardians = this.state.deletedGuardians;
        this.props.sendRequest(newMember, data)
      }
    }
  }

  /** After Stripe card payment succeeds — persist OnsiteUser + Membership with isStripe. */
  completeStripeMembership = async () => {
    const image = this.state.pendingImage || '';
    const customerId =
      this.state.customerId ||
      (this.state.selectedUser.selected && this.state.selectedUser.user.customerId) ||
      '';
    const subscriptionId = this.state.subscriptionId;
    if (!subscriptionId) {
      const alert = _.clone(emptyAlert);
      alert.type = 'error';
      alert.showAlert = true;
      alert.message = 'Missing Stripe subscription id';
      alert.callback = () => this.setState({ alert: _.clone(emptyAlert) });
      this.setState({ alert });
      return;
    }

    const membership = {
      ...this.buildMembershipFields(),
      startDate: new Date().toString(),
      isStripe: true,
      customerId,
      subscriptionId,
      status: 'active',
      redirectId: 'stripe',
      redirectUrl: 'stripe'
    };

    var data;
    if (this.state.newUserRequired) {
      data = {
        user: this.getUserObj(image),
        membership,
        guardians: this.state.guardians
      };
      if (customerId) data.user.customerId = customerId;
      this.props.sendRequest(newUserMember, data);
    } else {
      if (image && image !== '') {
        this.props.sendRequest(updateUser, {
          id: this.state.selectedUser.user.id,
          properties: { image }
        });
      }
      data = {
        id: this.state.selectedUser.user.id,
        userId: this.state.selectedUser.user.id,
        membership,
        guardians: this.state.guardians,
        deletedGuardians: this.state.deletedGuardians
      };
      this.props.sendRequest(newMember, data);
    }
  }

  generateReferenceNumber = (prefix) => {
    var today = new Date();
    const year = today.getFullYear();
    var month = today.getMonth() + 1;
    if (month < 10) month = '0' + month;
    var day = today.getDate();
    if (day < 10) day = '0' + day;
    const randomNo = Math.floor((Math.random() * 900000) + 100000);

    return (prefix + year + month + day + randomNo);
  }

  b64toBlob = (b64Data, contentType, sliceSize) => {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    var byteCharacters = atob(b64Data);
    var byteArrays = [];

    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);

      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      var byteArray = new Uint8Array(byteNumbers);

      byteArrays.push(byteArray);
    }

    var blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  updateUser = (id, data) => {
    if (data && data.customerId) {
      this.setState((prev) => ({
        customerId: data.customerId,
        selectedUser: prev.selectedUser.selected
          ? {
              ...prev.selectedUser,
              user: { ...prev.selectedUser.user, customerId: data.customerId }
            }
          : prev.selectedUser
      }))
    }
    if (!this.state.newUserRequired && id) {
      this.props.sendRequest(updateUser, { id: id, properties: data })
    }
  }

  submitWithPayment = (paymentMethod) => {
    this.setState(
      {
        paymentMethod: paymentMethod,
        paymentDone: true,
        showPayment: false
      },
      () => {
        if (config.useStripeMemberships) {
          this.completeStripeMembership()
        }
      }
    )
  }

  getUserObj = (image) => {
    if (this.state.selectedUser.selected) {
      return this.state.selectedUser.user
    } else {
      return _.clone({
        image: image,
        email: this.state.email,
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        address1: this.state.address1,
        address2: this.state.address2,
        city: this.state.city,
        country: this.state.country,
        county: this.state.county,
        postcode: this.state.postcode,
        phoneNumber: this.state.phoneNumber,
      });
    }
  }

  isFormValid = () => {
    var missingFields = []

    if (isBlank(this.state.firstName)) {
      missingFields.push('First Name');
    }
    if (isBlank(this.state.lastName)) {
      missingFields.push('Last Name');
    }
    if (isBlank(this.state.email)) {
      missingFields.push('Email');
    }
    if (isBlank(this.state.phoneNumber)) {
      missingFields.push('Phone Number');
    }

    var message = ''
    if (this.state.newUserRequired && missingFields.length === 0 && this.state.selectedMember.memberIndex !== null) {
      return true;
    } else if (!this.state.newUserRequired && this.state.selectedUser.selected && this.state.selectedMember.memberIndex !== null) {
      return true;
    }

    if (this.state.newUserRequired && missingFields.length > 0) {
      if (missingFields.length === 1) {
        message = 'Field ' + missingFields[0] + ' is blank';
      } else if (missingFields.length > 1) {
        var last = missingFields.pop()
        message = 'Fields ' + missingFields.join(', ') + ' and ' + last + ' are blank';
      }
    } else if (!this.state.newUserRequired && !this.state.selectedUser.selected) {
      message = pleaseSelectUText;
    } else if (this.state.selectedMember.memberIndex === null) {
      message = pleaseSelectTText;
    }

    var alert = {
      showAlert: true,
      message: message,
      type: 'warning',
      callback: () => {
        this.setState({ alert: _.clone(emptyAlert) })
      }
    }
    this.setState({ alert })
    return false;
  }

  getText = () => {
    if (this.props.requestFailed) {
      return errorText;
    } else if (this.props.requestLoading) {
      return loadingText;
    } else {
      return newMemberText;
    }
  }

  checkForAlert = () => {
    if (this.state.alert.showAlert) {
      return <Alert alert={this.state.alert} />
    } else if (this.props.requestFailed) {
      console.log('requestFailed')
      var alert = _.clone(emptyAlert);
      alert.type = 'error';
      alert.showAlert = true;
      alert.message = tryAgainText;
      alert.callback = () => {
        this.props.changeFinished();

        if (this.state.redirectCompleted) {
          this.animateClose();
          window.location = window.location.href.split('membershipSuccess')[0]
        } else {
          this.afterMembershipCreated();
        }
      }

      return <Alert alert={alert} />
    } else if (this.props.requestFinished) {
      console.log('requestFinished')
      var alert2 = _.clone(emptyAlert);
      alert2.type = 'success';
      alert2.showAlert = true;
      alert2.message = config.useStripeMemberships ? stripeSuccessText : '';
      alert2.callback = () => {
        this.props.changeFinished();
        if (this.state.redirectCompleted) {
          this.animateClose();
          window.location = window.location.href.split('membershipSuccess')[0]
        } else {
          this.afterMembershipCreated();
        }
      }

      return <Alert alert={alert2} />
    } else {
      return void (0)
    }
  }

  /** GoCardless → bank redirect; Stripe → close window (no redirectUrl navigation). */
  afterMembershipCreated = () => {
    const redirectUrl = this.props.membership && this.props.membership.redirectUrl;
    if (
      redirectUrl &&
      redirectUrl !== 'stripe' &&
      !config.useStripeMemberships
    ) {
      window.location.replace(redirectUrl);
      return;
    }
    this.animateClose();
  }

  animateCloseOpen = (completed) => {
    var redirect = this.props.userForBooking.redirect;
    if (this.props.userForBooking.required && !completed)
      this.props.newUserNotRequired();
    this.setState({
      shouldClose: true
    }, () => {
      setTimeout(() => {
        this.props.closeOpenWindow(redirect)
      }, 500)
    })
  }

  animateClose = () => {
    this.setState({
      shouldClose: true
    }, () => {
      this.props.sendRequest(fetchAll)
      this.props.sendRequest(fetchLatest)
      setTimeout(() => {
        this.props.closeWindow()
      }, 500)
    })
  }

  getPayAmount = () => {
    const plan = this.getAvailableMemberships()[this.state.selectedMember.memberIndex];
    if (!plan) return 0;
    if (config.useStripeMemberships) {
      return formatStripePayAmount(plan, this.state.selectedMember.memberType);
    }
    const prices = this.state.membershipPrices || DEFAULT_MEMBERSHIP_PRICES
    return formatMembershipPayAmount(
      plan,
      this.state.selectedMember.memberType,
      this.state.familyChildCount,
      prices
    );
  }

  toogleOpenedMember = (i) => {
    var openedMember = this.state.openedMember;
    openedMember[i] = !openedMember[i];

    this.setState({
      openedMember: openedMember
    })
  }

  selectMembership = (i, type) => {
    const next = { memberIndex: i, memberType: type };
    const plan = this.getAvailableMemberships()[i];
    if (plan && plan.family) {
      this.setState({
        selectedMember: next,
        familyChildCount: clampFamilyChildCount(this.state.familyChildCount, plan)
      });
    } else {
      this.setState({
        selectedMember: next
      });
    }
  }

  changeFamilyChildCount = (e, planIndex) => {
    const member = this.getAvailableMemberships()[planIndex];
    if (!member || !member.family || member.familyPlan !== 'multipleChildren') return;
    const sm = this.state.selectedMember;
    const nextType =
      sm.memberIndex === planIndex && sm.memberType != null ? sm.memberType : 1;
    this.setState({
      familyChildCount: clampFamilyChildCount(e.target.value, member),
      selectedMember: {
        memberIndex: planIndex,
        memberType: nextType
      }
    });
  }

  getMemberships = () => {
    if (config.useStripeMemberships && this.state.stripePlansLoading) {
      return <div className="memberCatalogStatus">Loading memberships…</div>
    }
    if (config.useStripeMemberships && this.state.stripePlansError) {
      return <div className="memberCatalogStatus">{this.state.stripePlansError}</div>
    }

    const plans = this.getAvailableMemberships()
    if (!plans.length) {
      return (
        <div className="memberCatalogStatus">
          There are no membership options available for this location at the moment.
        </div>
      )
    }

    const s = this.state.selectedMember;

    return plans.map((member, i) => {
      const firstSelected = s.memberIndex !== null && s.memberIndex === i && s.memberType === 1;
      const secondSelected = s.memberIndex !== null && s.memberIndex === i && s.memberType === 2;
      const someSelected = s.memberIndex !== null;
      const showMonthly = !config.useStripeMemberships || !!findStripePrice(member, 'month')
      const showYearly = !config.useStripeMemberships || !!findStripePrice(member, 'year')

      return (
        <div className={'memberWrapper'} key={member.stripeProduct ? member.stripeProduct.id : i}>
          <div className='memberRow'>
            <IosArrowDown onClick={() => this.toogleOpenedMember(i)} className='dropdownIcon' fontSize='5px' color='#fff' />
            <div onClick={() => this.toogleOpenedMember(i)} className='memberName'>{member.name}</div>

            {showMonthly && <div className={'memberSelect' + (someSelected && !firstSelected ? ' noBorder' : '')} onClick={() => this.selectMembership(i, 1)}>{monthlyText}</div>}
            {showYearly && <div className={'memberSelect' + (someSelected && !secondSelected ? ' noBorder' : '')} onClick={() => this.selectMembership(i, 2)}>{months12Text}</div>}
          </div>
          {this.state.openedMember[i] && <div className="memberDesc">
            {member.description.map((point, j) => {
              return (
                <div className="descText" key={j}>
                  <div className="descBullet">{'-'}</div>
                  <div>{point}</div>
                </div>
              )
            })}
            {member.family && member.familyPlan === 'multipleChildren' && (
              <div className="familyChildRow">
                <div className="descText familyChildLabel">
                  <div className="descBullet">{'-'}</div>
                  <label htmlFor={'familyChildCount-' + i}>{childrenOnPlanText}</label>
                </div>
                <select
                  id={'familyChildCount-' + i}
                  className="familyChildSelect"
                  value={clampFamilyChildCount(this.state.familyChildCount, member)}
                  onChange={(e) => this.changeFamilyChildCount(e, i)}
                  disabled={this.props.requestLoading}
                >
                  {[...Array((member.maxChildren || 8) - (member.minChildren || 2) + 1)].map((_, k) => {
                    const n = (member.minChildren || 2) + k;
                    return (
                      <option value={n} key={n}>{n}</option>
                    );
                  })}
                </select>
              </div>
            )}
            {member.family && member.familyPlan === 'twoAdultsTwoChildren' && (
              <div className="familyChildRow">
                <div className="descText">
                  <div className="descBullet">{'-'}</div>
                  <div>{coversTwoAdultsTwoChildrenText}</div>
                </div>
              </div>
            )}
          </div>}
        </div>
      )
    })
  }

  openPayment = () => {
    if (!this.isFormValid())
      return;
    this.setState({
      showPayment: true
    })
  }

  closePayment = () => {
    this.setState({
      showPayment: false
    })
  }

  toogleNewUser = () => {
    var pictureQueue = this.state.pictureQueue;
    var newUserRequired = this.state.newUserRequired;
    if (!newUserRequired) {
      pictureQueue.push(1)
    } else {
      pictureQueue = [];
    }

    this.setState({
      pictureQueue: pictureQueue,
      newUserRequired: !newUserRequired
    })
  }

  selectUser = (user) => {
    var isSubscribed = isActivelySubscribed(user.membership);
    if (!isSubscribed) {
      if (!user.image) {
        user.image = '';
      }

      var pictureQueue = this.state.pictureQueue;
      if (user.image === '') {
        pictureQueue.push(1)
      }
      this.setState({
        selectedUser: {
          user: user,
          selected: true,
        },
        openedGuardian: null,
        pictureQueue: pictureQueue,
        guardians: _.cloneDeep(user.guardians)
      })
    } else {
      var alert = _.clone(emptyAlert);
      alert.type = 'warning';
      alert.showAlert = true;
      alert.message = userSubscribedText;
      alert.callback = () => {
        this.setState({ alert: _.clone(emptyAlert) })
      }
      this.setState({ alert })
    }
  }

  unselectUser = () => {
    this.setState({
      selectedUser: {
        user: {},
        selected: false,
        pictureQueue: []
      }
    })
  }

  setSubscription = (id) => {
    this.setState({
      subscriptionId: id
    })
  }

  filterSearchItems = () => {
    var items = _.clone(this.props.users);
    var search = this.state.search;
    return items.filter((item) => {
      if (!item) return false
      if (
        item.firstName &&
        item.firstName.substring(0, search.length).toLowerCase() ===
          search.toLowerCase()
      )
        return true
      if (
        item.lastName &&
        item.lastName.substring(0, search.length).toLowerCase() ===
          search.toLowerCase()
      )
        return true
      if (
        item.email &&
        item.email.substring(0, search.length).toLowerCase() ===
          search.toLowerCase()
      )
        return true
      return false
    })
  }

  runSearch = () => {
    var items = []
    if (this.state.search === '') {
      items = Array.isArray(this.props.recentUsers)
        ? this.props.recentUsers
        : []
    } else {
      items = this.filterSearchItems()
    }

    this.setState({
      searchResults: items,
      hasSearched: true
    })
  }

  addGuardian = () => {
    const emptyGuardian = {
      firstName: '',
      lastName: '',
      image: '',
      temp: true
    }

    if (this.state.openedGuardian === null) {
      var pictureQueue = this.state.pictureQueue;
      pictureQueue.push(2)

      this.setState({
        pictureQueue: pictureQueue,
        openedGuardian: this.state.guardians.length,
        guardians: [...this.state.guardians, emptyGuardian]
      })
    } else {
      var guardians = this.state.guardians;
      delete guardians[this.state.openedGuardian]['temp']
      var pictureQueue2 = this.state.pictureQueue;

      this.setState({
        guardians: guardians,
        openedGuardian: null,
        pictureQueue: pictureQueue2.filter(item => item !== 2)
      })
    }
  }

  changeGuardian = (property, e) => {
    var guardians = this.state.guardians;
    guardians[this.state.openedGuardian][property] = e.target.value;
    this.setState({ guardians })
  }

  deleteGuardian = (index) => {
    var guardians = this.state.guardians;
    var deletedGuardians = this.state.deletedGuardians;

    if (guardians[index].id) {
      console.log('pushed')
      deletedGuardians.push(guardians[index].id);
    }
    guardians.splice(index, 1);

    if (this.state.openedGuardian !== null && this.state.openedGuardian > index) {
      this.setState({
        guardians: guardians,
        deletedGuardians: deletedGuardians,
        openedGuardian: this.state.openedGuardian - 1
      })
    } else {
      this.setState({
        guardians: guardians,
        deletedGuardians: deletedGuardians
      })
    }
  }

  modifyGuardian = (index) => {
    var pictureQueue = this.state.pictureQueue;
    pictureQueue = pictureQueue.filter(item => item !== 2);

    pictureQueue.push(2);

    this.setState({
      openedGuardian: index,
      pictureQueue: pictureQueue,
    })
  }

  getSearchItems = () => {
    if (!this.state.hasSearched) return null

    const items = Array.isArray(this.state.searchResults)
      ? this.state.searchResults
      : []
    if (!items.length) {
      return (
        <div className="searchWrapper searchBorder">
          <div className="searchRow smallText noBorder">{noUsersFoundText}</div>
        </div>
      )
    }

    return (
      <div className="searchWrapper searchBorder searchResultsList">
        {items.map((item, index) => {
          return (
            <div
              className={
                'searchRow smallText' +
                ((index + 1) === items.length ? ' noBorder' : '')
              }
              key={item.id || index}
              onClick={() => this.selectUser(item)}
            >
              <div>{item.firstName + ' ' + item.lastName}</div>
              <div>{item.email}</div>
            </div>
          )
        })}
      </div>
    )
  }

  getRegisterInputs = () => {
    const inputs = [
      { property: 'firstName', title: 'First name' },
      { property: 'lastName', title: 'Last name' },
      { gap: true },
      { property: 'email', title: 'Email' },
      { property: 'phoneNumber', title: 'Phone number' },
      { gap: true },
      { property: 'address1', title: 'Address 1' },
      { property: 'address2', title: 'Address 2' },
      { property: 'city', title: 'City' },
      { property: 'county', title: 'County' },
      { property: 'country', title: 'Country' },
      { property: 'postcode', title: 'Postcode' }
    ]

    return inputs.map((item, index) => {
      if (item.gap) {
        return <div key={index} className="formGap" />;
      } else {
        return (
          <div key={index} className="inputWrapper">
            <input
              type="text"
              value={this.state[item.property]}
              disabled={this.props.requestLoading}
              onChange={(e) => this.handleChange(item.property, e)}
              placeholder={item.title}
            />
          </div>
        );
      }
    })
  }

  getImage = () => {
    var image = '';
    let token = JSON.parse(window.localStorage.getItem('userData')).token;


    if (this.state.selectedUser.selected) {
      const header = "data:image";
      image = this.state.selectedUser.user.image;
      if (image !== '' && image.substring(0, header.length) !== header) {
        image = config.serverURL + '/ImageUploads/wackykingdom/download/' + image + '?access_token=' + token;
      }
    } else if (this.state.newUserRequired) {
      image = this.state.image;
    }

    return image;
  }

  getCameraView = (image, pictureCase, key) => {
    var showWebcam = false;

    if ((pictureCase === 1 || pictureCase === 2) && this.state.pictureQueue.length > 0 && this.state.pictureQueue[0] === 1) {
      showWebcam = true;
    }

    if (pictureCase === 3 && this.state.pictureQueue.length > 0 && this.state.pictureQueue[0] === 2) {
      showWebcam = true;
    }

    return (
      <div style={{ width: '100%' }} key={key ? key : null}>
        {image === '' && <div className="videoWrapper">
          {showWebcam ?
            <Webcam
              width={200}
              height={200}
              audio={false}
              ref={this.webcamRef}
              screenshotFormat="image/png"
              minScreenshotWidth={640}
              minScreenshotHeight={480}
              videoConstraints={{ facingMode: 'user' }}
            />
            :
            <div className="cameraWarning">Please take a picture with other window first</div>
          }
        </div>}
        {image !== '' && <div className="videoWrapper avatarImage" style={{ backgroundImage: "url('" + image + "')" }}></div>}
        {showWebcam && image === '' && <div className="takePicture">
          <div onClick={() => this.takePicture(pictureCase)} className="buttonWrapper">{takePictureText}</div>
        </div>}
        {image !== '' && <div className="takePicture">
          <div onClick={() => this.removePicture(pictureCase)} className="buttonWrapper">{takeAgainText}</div>
        </div>}
      </div>
    )
  }

  getAddGuardian = () => {
    const inputs = [
      { property: 'firstName', title: 'First name' },
      { property: 'lastName', title: 'Last name' }
    ]

    var views = inputs.map((input, index) => {
      return (
        <div key={index} className="inputWrapper">
          <input
            type="text"
            value={this.state.guardians[this.state.openedGuardian][input.property]}
            disabled={this.props.requestLoading}
            onChange={(e) => this.changeGuardian(input.property, e)}
            placeholder={input.title}
          />
        </div>
      );
    });

    views.unshift(this.getCameraView(this.state.guardians[this.state.openedGuardian].image, 3, 2))

    return views;
  }

  userCheck = (view) => {
    if (this.state.newUserRequired || this.state.selectedUser.selected) {
      return view;
    } else {
      return <div></div>
    }
  }

  render() {
    var mainClass = 'memberWindow'
    if (this.state.shouldClose) {
      mainClass += ' closeWindow';
    }
    if (this.state.redirectFailed || this.state.redirectCompleted) {
      mainClass += ' centerWindow';
    }

    return (
      <div className={mainClass}>
        <div className={(this.state.redirectFailed || this.state.redirectCompleted) ? "statusForm" : "memberForm"}>
          {!(this.state.redirectFailed || this.state.redirectCompleted) && <div>
            <IosCloseCircleOutline onClick={() => this.animateClose()} className="closeIcon" fontSize="30px" color="#fff" />
            {this.state.newUserRequired ?
              <IosArrowRoundBack onClick={() => this.toogleNewUser()} className="backIcon" fontSize="45px" color="#fff" /> : void (0)
            }
            <div className="titleText">{newMemberText}</div>
            {this.state.newUserRequired && this.getCameraView(this.getImage(), 1)}
            {this.state.selectedUser.selected && this.getCameraView(this.getImage(), 2)}
            {!this.state.newUserRequired ?
              <div>
                {!this.state.selectedUser.selected ?
                  <div className="searchWindow">
                    <div className="subtitleText">{pleaseSelectUText}</div>
                    <div className="inputWrapper searchBarRow">
                      <input
                        type="text"
                        value={this.state.search}
                        disabled={this.props.requestLoading}
                        onChange={(e) => this.setState({ search: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') this.runSearch()
                        }}
                        placeholder={searchPlaceholderText}
                      />
                      <div
                        className="buttonWrapper searchButton"
                        onClick={() => this.runSearch()}
                      >
                        {searchText}
                      </div>
                    </div>
                    <div className="searchWrapper addUserWrapper">
                      <div className="searchRow addUserRow" onClick={() => this.toogleNewUser()}>{addUserText}</div>
                    </div>
                    {this.getSearchItems()}
                  </div> :
                  <div className="searchWrapper selectedWrapper">
                    <div className="searchRow smallText selectedRow">
                      <div>{this.state.selectedUser.user.email + ''}</div>
                    </div>
                    {!this.state.paymentDone && <div className="searchChange" onClick={() => this.unselectUser()}>{changeText}</div>}
                  </div>
                }
              </div> : void (0)
            }
            {this.state.newUserRequired && <div>{this.getRegisterInputs()}</div>}
            {this.userCheck(<div className="subtitleText">{guardiansText}</div>)}
            {this.userCheck(<div className="marginTop"></div>)}
            {this.userCheck(this.state.guardians.map((guardian, index) => {
              return (index !== this.state.openedGuardian ? <div key={index} className="searchWrapper selectedWrapper">
                <div className="searchRow smallText selectedRow">
                  <div>{guardian.firstName + ' ' + guardian.lastName}</div>
                </div>
                {!this.state.paymentDone && !guardian.temp && <div className="searchChange" onClick={() => this.deleteGuardian(index)}>{deleteText}</div>}
                {!this.state.paymentDone && <div className="searchChange" onClick={() => this.modifyGuardian(index)}>{guardian.temp ? notSavedText : changeText}</div>}
              </div> : <div key={index}></div>)
            }))}
            {this.state.openedGuardian !== null ? this.userCheck(this.getAddGuardian()) : void (0)}
            {this.userCheck(<div className="addGuardian" onClick={() => this.addGuardian()}>{this.state.openedGuardian === null ? addGuardianText : saveGuardianText}</div>)}
            <div className="subtitleText">{selectMemberText}</div>
            {this.getMemberships()}
            <div className="subtitleText">{totalText}</div>
            <div className="amountInputRow">
              <div>{amountText}</div>
              <div>{'£ ' + this.getPayAmount()}</div>
            </div>
            <div className="memberButtons">
              <div className="buttonWrapper" onClick={() => this.submit()}>
                {config.useStripeMemberships ? paySubmitText : submitText}
              </div>
            </div>
            <div className="marginBottom"></div>
          </div>}
          {this.state.redirectCompleted && !this.state.subscribeLoading && <div className="statusWrapper">
            <IosCheckmarkCircleOutline fontSize="70px" className="membershipStatus" />
            <div className="statusText">{successText}</div>
          </div>}
          {this.state.redirectFailed && <div className="statusWrapper">
            <IosCloseCircleOutline fontSize="70px" className="membershipStatus" />
            <div className="statusText">{failureText}</div>
          </div>}
          {this.state.redirectCompleted && this.state.subscribeLoading && <div className="statusWrapper">
            <BarLoader
              size={150}
              color={'#fff'}
              sizeUnit={"px"}
              css={{ margin: 'auto', marginTop: 15, marginBottom: 15 }}
              loading={true}
            />
            <div className="statusText">{requestText}</div>
          </div>}
        </div>
        {this.state.showPayment && config.useStripeMemberships && (
          <Payment
            amount={0}
            fee={0}
            subscribe={true}
            type={this.state.stripeProductName}
            interval={this.state.selectedMember.memberType === 1 ? 'month' : 'year'}
            updateUser={this.updateUser}
            setSubscription={this.setSubscription}
            user={
              this.state.selectedUser.selected
                ? this.state.selectedUser.user
                : this.getUserObj(this.state.pendingImage || '')
            }
            successCallback={this.submitWithPayment}
            closePayment={this.closePayment}
          />
        )}
        {this.checkForAlert()}
      </div>
    )
  }
}

const mapStateToProps = ({ users }) => ({
  users: users.users,
  membership: users.membership,
  recentUsers: users.recentUsers,
  requestFailed: users.requestFailed,
  userForBooking: users.userForBooking,
  requestLoading: users.requestLoading,
  requestFinished: users.requestFinished
})

const mapDispatchToProps = dispatch => bindActionCreators({ sendRequest, changeFinished, newUserNotRequired, fetchLatest, fetchAll }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Member)
